(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion"] && !Shopify.designMode) return;
  try {
    
  class AccordionComponent extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.items = this.querySelectorAll('[data-accordion-item]');

      if (!this.items.length) return;

      // Bind methods
      this.toggle = this.toggle.bind(this);

      // Add event listeners and open first item
      this.items.forEach((item, index) => {
        const trigger = item.querySelector('[data-accordion-trigger]');
        if (trigger) {
          trigger.addEventListener('click', () => this.toggle(item));

          // Open first item by default
          //if (index === 0) {
          //  this.open(item);
          //}
        }
      });
    }

    toggle(item) {
      const trigger = item.querySelector('[data-accordion-trigger]');
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        this.close(item);
      } else {
        this.open(item);
      }
    }

    open(item) {
      const trigger = item.querySelector('[data-accordion-trigger]');
      const content = item.querySelector('[data-accordion-content]');

      if (!trigger || !content) return;

      trigger.setAttribute('aria-expanded', 'true');
      content.setAttribute('aria-hidden', 'false');
      item.classList.add('accordion-item--open');

      // Set max-height for animation
      content.style.maxHeight = content.scrollHeight + 'px';
    }

    close(item) {
      const trigger = item.querySelector('[data-accordion-trigger]');
      const content = item.querySelector('[data-accordion-content]');

      if (!trigger || !content) return;

      trigger.setAttribute('aria-expanded', 'false');
      content.setAttribute('aria-hidden', 'true');
      item.classList.remove('accordion-item--open');

      // Reset max-height for animation
      content.style.maxHeight = '0';
    }

    connectedCallback() {
      // Reinitialize when section is reloaded in theme editor
      if (Shopify && Shopify.designMode) {
        this.init();
      }
    }
  }

  if (!customElements.get('accordion-component')) {
    customElements.define('accordion-component', AccordionComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
class AnnouncementBarComponent extends HTMLElement {
  constructor() {
    super();
    this.closeButton = this.querySelector('.announcement-bar__close');
    this.announcementId = this.dataset.announcementId;
    this.storageKey = `announcement-bar-dismissed:${this.announcementId}`;
  }

  connectedCallback() {
    if (this.isDismissed()) {
      this.hidden = true;
      this.updateHeightVariable();
      return;
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.dismiss.bind(this));
    }

    // Set CSS variable for announcement bar height
    this.updateHeightVariable();

    this.resizeHandler = this.updateHeightVariable.bind(this);
    window.addEventListener('resize', this.resizeHandler);

    // Track visible height as user scrolls with RAF throttling
    this.scrollHandler = () => {
      if (!this.scrollTicking) {
        window.requestAnimationFrame(() => {
          this.updateHeightVariable();
          this.scrollTicking = false;
        });
        this.scrollTicking = true;
      }
    };

    window.addEventListener('scroll', this.scrollHandler, { passive: true });
  }

  disconnectedCallback() {
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }

    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
    }
  }

  updateHeightVariable() {
    if (this.hidden) {
      document.documentElement.style.setProperty('--announcement-bar-height', '0px');
      return;
    }

    const rect = this.getBoundingClientRect();
    const visibleHeight = Math.max(0, rect.bottom);
    document.documentElement.style.setProperty(
      '--announcement-bar-height',
      `${visibleHeight}px`
    );
  }

  isDismissed() {
    try {
      return localStorage.getItem(this.storageKey) === 'true';
    } catch (e) {
      return false;
    }
  }

  dismiss() {
    try {
      localStorage.setItem(this.storageKey, 'true');
    } catch (e) {
      // localStorage not available
    }

    this.hidden = true;
    this.updateHeightVariable();
  }
}

if (!customElements.get('announcement-bar-component')) {
  customElements.define('announcement-bar-component', AnnouncementBarComponent);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
  class BlogArticlesManager extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.typeFilter = document.getElementById('type-filter');
      this.topicFilter = document.getElementById('topic-filter');
      this.sortFilter = document.getElementById('sort-filter');
      this.blogUrl = this.getAttribute('data-blog-url');
      this.articlesGrid = this.querySelector('#blog-articles-grid');
      this.defaultSort = this.getAttribute('data-default-sort') || 'published_at_desc';

      // Sort mapping
      this.sortMapping = {
        'Newest First': 'published_at_desc',
        'Oldest First': 'published_at_asc',
        'A-Z': 'title_asc',
        'Z-A': 'title_desc',
      };

      this.init();
    }

    init() {
      // Apply default sort on page load
      this.sortArticles(this.defaultSort);

      // Handle sort dropdown - sort without page reload
      if (this.sortFilter) {
        this.sortFilter.addEventListener('change', () => {
          const sortKey = this.sortMapping[this.sortFilter.value] || this.defaultSort;
          this.sortArticles(sortKey);
        });
      }

      // Handle type/topic filters - navigate with tags
      if (this.typeFilter) {
        this.typeFilter.addEventListener('change', () => this.updateFilters());
      }
      if (this.topicFilter) {
        this.topicFilter.addEventListener('change', () => this.updateFilters());
      }
    }

    sortArticles(sortValue) {
      const articles = Array.from(this.articlesGrid.querySelectorAll('.blog-article'));

      articles.sort((a, b) => {
        switch (sortValue) {
          case 'published_at_asc':
            return parseInt(a.dataset.published) - parseInt(b.dataset.published);
          case 'published_at_desc':
            return parseInt(b.dataset.published) - parseInt(a.dataset.published);
          case 'title_asc':
            return a.dataset.title.localeCompare(b.dataset.title);
          case 'title_desc':
            return b.dataset.title.localeCompare(a.dataset.title);
          default:
            return 0;
        }
      });

      articles.forEach((article) => this.articlesGrid.appendChild(article));
    }

    updateFilters() {
      const tags = [];

      if (this.typeFilter && this.typeFilter.value) {
        tags.push(this.typeFilter.value);
      }
      if (this.topicFilter && this.topicFilter.value) {
        tags.push(this.topicFilter.value);
      }

      let newUrl = this.blogUrl;
      if (tags.length > 0) {
        newUrl += '/tagged/' + tags.map((t) => t.toLowerCase().replace(/\s+/g, '-')).join('+');
      }

      window.location.href = newUrl;
    }
  }

  customElements.define('blog-articles-manager', BlogArticlesManager);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartForm extends HTMLElement {
    constructor() {
      super();
      this.handleButtonClick = this.handleButtonClick.bind(this);
      this.handleInputChange = this.handleInputChange.bind(this);
      this.submitForm = this.submitForm.bind(this);
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.incrementers = Array.from(this.form.querySelectorAll('.ep-incrementer'));
      this.incrementers.forEach((incrementer) => {
        incrementer
          .querySelectorAll('[data-action]')
          .forEach((button) => button.addEventListener('click', this.handleButtonClick));

        const hiddenInput = incrementer.querySelector('.ep-incrementer__input');
        if (hiddenInput) {
          hiddenInput.addEventListener('change', this.handleInputChange);
        }
      });
    }

    disconnectedCallback() {
      if (!this.incrementers) return;

      this.incrementers.forEach((incrementer) => {
        incrementer
          .querySelectorAll('[data-action]')
          .forEach((button) => button.removeEventListener('click', this.handleButtonClick));

        const hiddenInput = incrementer.querySelector('.ep-incrementer__input');
        if (hiddenInput) {
          hiddenInput.removeEventListener('change', this.handleInputChange);
        }
      });
    }

    handleButtonClick(event) {
      const button = event.currentTarget;
      if (button.disabled) return;

      const incrementer = button.closest('.ep-incrementer');
      if (!incrementer) return;

      const hiddenInput = incrementer.querySelector('.ep-incrementer__input');
      const valueDisplay = incrementer.querySelector('.ep-incrementer__number');
      if (!hiddenInput || !valueDisplay) return;

      const step = parseInt(incrementer.dataset.step, 10) || 1;
      const minValue = parseInt(incrementer.dataset.min, 10);
      const maxValue = parseInt(incrementer.dataset.max, 10);

      let currentValue = parseInt(hiddenInput.value, 10);
      if (Number.isNaN(currentValue)) {
        currentValue = 0;
      }

      const action = button.dataset.action;
      let nextValue = currentValue;

      if (action === 'increment') {
        nextValue = currentValue + step;
        if (!Number.isNaN(maxValue)) {
          nextValue = Math.min(nextValue, maxValue);
        }
      } else if (action === 'decrement') {
        nextValue = currentValue - step;
        if (!Number.isNaN(minValue)) {
          nextValue = Math.max(nextValue, minValue);
        }
      }

      if (nextValue === currentValue) {
        return;
      }

      hiddenInput.value = nextValue;
      valueDisplay.textContent = nextValue;

      const minusButton = incrementer.querySelector('[data-action="decrement"]');
      const plusButton = incrementer.querySelector('[data-action="increment"]');

      if (minusButton && !Number.isNaN(minValue)) {
        minusButton.disabled = nextValue <= minValue;
      }
      if (plusButton && !Number.isNaN(maxValue)) {
        plusButton.disabled = nextValue >= maxValue;
      }

      this.submitForm();
    }

    handleInputChange() {
      this.submitForm();
    }

    submitForm() {
      if (!this.form) return;
      if (typeof this.form.requestSubmit === 'function') {
        this.form.requestSubmit();
      } else {
        this.form.submit();
      }
    }
  }

  if (!customElements.get('cart-form')) {
    customElements.define('cart-form', CartForm);
  }

  // Cart Recharge edit JS start
  const settings = {
    objModalPopupBtn: '.ep-cart_subscription_modal',
    objModalCloseBtn: '.ep-cart_overlay, .ep-cart_close_btn',
    objModalDataAttr: 'data-popup',
  };

  let currentLine = null;
  let currentVariant = null;
  let variantData = [];
  let sellingPlansData = {};

  // --- Open Modal ---//
  document.querySelectorAll(settings.objModalPopupBtn).forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      const popupName = button.getAttribute(settings.objModalDataAttr);
      if (!popupName) return;

      currentLine = Number(button.dataset.line);
      currentVariant = Number(button.dataset.currentVariant);

      const variantDataEl = document.querySelector(`#variant-plans-${currentLine}`);
      if (!variantDataEl) return;

      const parsedData = JSON.parse(variantDataEl.textContent);
      variantData = parsedData.variants || [];
      sellingPlansData = parsedData.selling_plans || {};

      const container = document.getElementById('ep-cart_variant_option_container');
      container.innerHTML = ''; // Clear previous content

      let html = '';

      variantData.forEach((variant) => {
        const planId = variant.selling_plan_ids[0];
        const plan = sellingPlansData[planId];
        let originalPrice = parseFloat(variant.price.replace(/[^0-9.-]+/g, ''));
        let discountedPrice = originalPrice;
        let savePercentage = 0;

        if (plan && plan.price_adjustments && plan.price_adjustments.length) {
          plan.price_adjustments.forEach((adj) => {
            if (adj.value_type === 'percentage') {
              savePercentage = adj.value;
              discountedPrice = discountedPrice * (1 - adj.value / 100);
            } else if (adj.value_type === 'fixed_amount') {
              savePercentage = Math.round((adj.value / originalPrice) * 100);
              discountedPrice = discountedPrice - adj.value;
            }
          });
        }

        let servings = 30;
        if (plan && plan.options && plan.options.length) {
          const frequencyOption = plan.options.find((opt) => opt.name.includes('Order Frequency'));
          if (frequencyOption) {
            const match = frequencyOption.value.match(/\d+/);
            if (match) servings = parseInt(match[0], 10);
          }
        }
        const perServingPrice = discountedPrice / servings;
        const formattedDiscountedPrice = `$${discountedPrice.toFixed(2)}`;
        const formattedCompareAtPrice = `$${originalPrice.toFixed(2)}`;
        const formattedPerServing = `$${perServingPrice.toFixed(2)}/serving`;

        // Footer price change for selected variant
        if (variant.id === currentVariant) {
          document.querySelector('.ep-cart_modal_price_footer').textContent = formattedDiscountedPrice;
        }

        html += `
        <div class="ep-cart_subscription_line_item ${variant.id === currentVariant ? 'selected-subscription' : ''}">
         ${variant.doctor_custom_recommended === true ? `<div class="ep-cart_recommended">${window.sptranslation['product.clinic_recommended_label']}</div>` : ''}
          <div class="ep-cart_container">
            <input type="radio" class="ep-cart_variant_radio_btn " name="variant_option" id="variant-${variant.id}" value="${variant.id}" data-plan-id="${planId}" ${variant.id === currentVariant ? 'checked' : ''}>
            <label for="variant-${variant.id}" class="ep-cart_subscription_line_item_label">
              <div class="ep-cart_subscription_main">
                <div class="ep-cart_subscription_left">
                  <span class="ep-cart_subscription_name">${variant.title}</span>
                  <span class="ep-cart_discount_badge">Save ${savePercentage}%</span>
                </div>
                <div class="ep-cart_subscription_right">
                  <div class="ep-cart_subscription_price_module">
                    <div class="ep-cart_subscription_price_container">
                      <span class="ep-cart_subscription_compare_at_price" style="text-decoration: line-through;">${formattedCompareAtPrice}</span>
                      <span class="ep-cart_subscription_original_price">${formattedDiscountedPrice}</span>
                    </div>
                    <div class="ep-cart_subscription_serving_module">
                      <span class="ep-cart_subscription_serving_price">${formattedPerServing}</span>
                    </div>
                  </div>
                </div>
              </div>
            </label>
          </div>
        </div>
        `;
      });

      container.innerHTML = html;

      // Attach "auto-submit" event on radio change
      const RADIO_CLASS = 'selected-subscription'; // the class you want to add
      container.querySelectorAll('.ep-cart_variant_radio_btn').forEach((radio) => {
        radio.addEventListener('change', () => {
          // 1. Remove the class from all parents
          container.querySelectorAll('.ep-cart_subscription_line_item').forEach((item) => {
            item.classList.remove(RADIO_CLASS);
          });

          // 2. Add the class to the current radio's parent
          const parent = radio.closest('.ep-cart_subscription_line_item');
          if (parent) {
            parent.classList.add(RADIO_CLASS);
          }

          // 3. update footer
          const priceEl = parent.querySelector('.ep-cart_subscription_original_price');
          if (priceEl) {
            const price = priceEl.textContent.trim();
            document.querySelector('.ep-cart_modal_price_footer').textContent = price;
          }

          // 4. Call the variant change function.
          applyVariantChange(radio);
        });
      });

      // Show modal
      const overlay = document.querySelector('.ep-cart_overlay');
      const modal = document.getElementById(popupName);
      if (overlay && modal) {
        overlay.style.display = 'block';
        modal.style.display = 'block';
        requestAnimationFrame(() => {
          overlay.style.opacity = '1';
          modal.style.opacity = '1';
        });
      }
    });
  });

  // --- Close Modal ---
  document.querySelectorAll(settings.objModalCloseBtn).forEach((closeBtn) => {
    closeBtn.addEventListener('click', () => {
      document.querySelectorAll('.modal, .ep-cart_overlay').forEach((el) => {
        el.style.opacity = '0';
        setTimeout(() => (el.style.display = 'none'), 300);
      });
    });
  });

  // --- Apply Variant Function ---
  function applyVariantChange(selectedRadio) {
    if (!currentLine) return;

    const selectedVariantId = Number(selectedRadio.value);
    const selectedPlanId = Number(selectedRadio.dataset.planId);

    if (!selectedVariantId || !selectedPlanId) {
      alert('Unable to find the associated subscription plan for this variant.');
      return;
    }

    // Remove old line
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(currentLine), quantity: 0 }),
    })
      .then(() => {
        // Add new variant with subscription
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: selectedVariantId,
            quantity: 1,
            selling_plan: selectedPlanId,
          }),
        });
      })
      .then((res) => res.json())
      .then((cart) => {
        location.reload();
      })
      .catch((err) => console.error('Error updating cart:', err));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroSection extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.enableTransparentHeader = this.dataset.enableTransparentHeader === 'true';
    }

    connectedCallback() {
      // Only apply transparency if this is the first hero section on the page
      if (this.isFirstHeroSection()) {
        this.updateHeaderTransparency(this.enableTransparentHeader);
      }

      // Listen for theme editor events
      document.addEventListener('shopify:section:load', this.handleSectionLoad);
      document.addEventListener('shopify:section:unload', this.handleSectionUnload);
    }

    disconnectedCallback() {
      this.updateHeaderTransparency(false);
      document.removeEventListener('shopify:section:load', this.handleSectionLoad);
      document.removeEventListener('shopify:section:unload', this.handleSectionUnload);
    }

    handleSectionLoad = (event) => {
      if (event.detail.sectionId === this.sectionId && this.isFirstHeroSection()) {
        this.updateHeaderTransparency(this.enableTransparentHeader);
      }
    };

    handleSectionUnload = (event) => {
      if (event.detail.sectionId === this.sectionId) {
        this.updateHeaderTransparency(false);
      }
    };

    isFirstHeroSection() {
      const allHeroSections = document.querySelectorAll('hero-section');
      return allHeroSections.length > 0 && allHeroSections[0] === this;
    }

    updateHeaderTransparency(enable) {
      const navigation = document.querySelector('navigation-component');
      if (!navigation) {
        return;
      }

      if (enable) {
        navigation.classList.add('ep-navigation--transparent');
      } else {
        navigation.classList.remove('ep-navigation--transparent');
      }
    }
  }

  if (!customElements.get('hero-section')) {
    customElements.define('hero-section', HeroSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["infographic"] && !Shopify.designMode) return;
  try {
    
  class InfographicViewer extends HTMLElement {
    constructor() {
      super();
      this.currentSvgUrl = null;
      this.currentChapter = 0;
      this.chapters = [];
      this._onResize = this._onResize.bind(this);
      this._resizeRaf = null;
      this.id = null;
      this.hasInitialized = false;
      this.hasLoadedInlineSvg = false;
      this.intersectionObserver = null;
    }

    connectedCallback() {
      const section = this.closest('section[data-section-type="infographic"]');
      const id = `shopify-section-${section.getAttribute('data-section-id')}`;
      this.id = id;

      // Use Intersection Observer to defer initialization until section is near viewport
      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.hasInitialized) {
              this.initializeSection();
            }
          });
        },
        {
          rootMargin: '200px 0px', // Start loading 200px before entering viewport
          threshold: 0,
        },
      );

      this.intersectionObserver.observe(this);
    }

    async initializeSection() {
      this.hasInitialized = true;
      this.intersectionObserver?.disconnect();

      this.setupChapters();
      // Load inline SVG once in viewport to initialize layer visibility
      await this.loadSVGForViewport();
      this.initializeHotspots();

      window.addEventListener('resize', this._onResize);

      this.classList.remove('loading');
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._onResize);
      this.intersectionObserver?.disconnect();
      if (this._resizeRaf) {
        cancelAnimationFrame(this._resizeRaf);
        this._resizeRaf = null;
      }
    }

    setupChapters() {
      const chapterLis = document.querySelectorAll(`#${this.id} .infographic__chapter`);

      for (let i = 0; i < chapterLis.length; i++) {
        const chapter = chapterLis[i];
        const index = i;
        const chapterid = chapter.getAttribute('data-infographic-id');
        const caption = this.querySelector(`#${this.id} .infographic__caption--${chapterid}`);

        chapter.addEventListener('click', () => {
          this.selectChapter(index);
        });

        this.chapters.push({
          li: chapter,
          svg_desktop: chapter.getAttribute('data-svg-desktop'),
          svg_mobile: chapter.getAttribute('data-svg-mobile') ?? chapter.getAttribute('data-svg-desktop'),
          caption: caption,
        });
      }

      // Select first chapter but don't load inline SVG yet
      this.updateChapterUI(this.currentChapter);
    }

    updateChapterUI(index) {
      for (let j = 0; j < this.chapters.length; j++) {
        if (j == index) {
          this.chapters[j].li.classList.add('infographic__chapter--selected');
          if (!!this.chapters[j].caption) {
            this.chapters[j].caption.classList.remove('infographic__caption--hidden');
          }
        } else {
          this.chapters[j].li.classList.remove('infographic__chapter--selected');
          if (!!this.chapters[j].caption) {
            this.chapters[j].caption.classList.add('infographic__caption--hidden');
          }
        }
      }
    }

    async selectChapter(index) {
      this.updateChapterUI(index);
      this.currentChapter = index;

      // Only load inline SVG when user interacts (clicks a chapter)
      // This defers the heavy SVG fetch until interaction
      await this.loadSVGForViewport();
      this.initializeHotspots();
    }

    _onResize() {
      // Only handle resize if we've already loaded inline SVG
      if (!this.hasLoadedInlineSvg) return;

      if (this._resizeRaf) return;
      this._resizeRaf = requestAnimationFrame(async () => {
        this._resizeRaf = null;
        this.classList.add('loading');
        const didReload = await this.loadSVGForViewport();
        if (didReload) this.initializeHotspots();
        this.classList.remove('loading');
      });
    }

    // injects the svg into the DOM so we can make it interactive
    async loadSVGForViewport() {
      if (this.chapters.length == 0) return false;
      if (this.currentChapter >= this.chapters.length) return false;
      if (this.currentChapter < 0) return false;

      const currentChapter = this.chapters[this.currentChapter];
      const svgUrl = currentChapter.svg_desktop;
      const svgUrlMobile = currentChapter.svg_mobile;

      const shouldUseMobile = window.innerWidth < 768;
      const desiredUrl = shouldUseMobile && svgUrlMobile ? svgUrlMobile : svgUrl;

      if (!desiredUrl) return false;
      if (this.currentSvgUrl === desiredUrl) return false;

      // make sure it's an svg
      if (!desiredUrl.includes('.svg')) {
        // if the url does not end with .svg, create an image element and set its src to the desiredUrl
        const svgContainer = this.querySelector(`#${this.id} .infographic-svg-container`);
        svgContainer.innerHTML = `<img src="${desiredUrl}" alt="Infographic Image" loading="lazy" decoding="async" />`;
        return false;
      }

      try {
        // Use low priority fetch to not compete with critical resources
        const response = await fetch(desiredUrl, { priority: 'low' });
        if (!response.ok) throw new Error('Network response was not ok');

        const svgText = await response.text();
        const parser = new DOMParser();
        const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');
        const svgElement = svgDoc.documentElement;

        // Scope all SVG IDs, classes, and internal references to avoid
        // conflicts when multiple infographic sections share the same page.
        const prefix = `${this.id}-`;

        // Collect original IDs/classes (needed for <style> rewriting), then prefix on elements
        const originalIds = [];
        svgElement.querySelectorAll('[id]').forEach((el) => {
          originalIds.push(el.getAttribute('id'));
          el.setAttribute('id', prefix + el.getAttribute('id'));
        });

        const originalClassNames = new Set();
        svgElement.querySelectorAll('[class]').forEach((el) => {
          const classes = el.getAttribute('class').split(/\s+/).filter(Boolean);
          classes.forEach((cls) => originalClassNames.add(cls));
          el.setAttribute('class', classes.map((cls) => prefix + cls).join(' '));
        });

        // Update href / xlink:href fragment references
        svgElement.querySelectorAll('[href], [xlink\\:href]').forEach((el) => {
          ['href', 'xlink:href'].forEach((attr) => {
            const val = el.getAttribute(attr);
            if (val?.startsWith('#')) {
              el.setAttribute(attr, '#' + prefix + val.slice(1));
            }
          });
        });

        // Update url(#...) references in inline styles and presentation attributes
        svgElement.querySelectorAll('[style], [clip-path], [mask], [fill], [stroke], [filter]').forEach((el) => {
          for (const attr of ['style', 'clip-path', 'mask', 'fill', 'stroke', 'filter']) {
            const val = el.getAttribute(attr);
            if (val?.includes('url(#')) {
              el.setAttribute(attr, val.replace(/url\(#([^)]+)\)/g, `url(#${prefix}$1)`));
            }
          }
        });

        // Rewrite selectors inside embedded <style> elements.
        // Regex with a boundary lookahead is required to prevent partial matches
        // (e.g. #button-1 must not match #button-10, .cls-2 must not match .cls-26).
        const boundary = '(?=[\\s,{:.\\[>~+]|$)';
        const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        svgElement.querySelectorAll('style').forEach((styleEl) => {
          let css = styleEl.textContent;
          originalIds.forEach((id) => {
            css = css.replace(new RegExp('#' + esc(id) + boundary, 'g'), '#' + prefix + id);
          });
          originalClassNames.forEach((cls) => {
            css = css.replace(new RegExp('\\.' + esc(cls) + boundary, 'g'), '.' + prefix + cls);
          });
          styleEl.textContent = css;
        });

        const svgContainer = this.querySelector(`#${this.id} .infographic-svg-container`);
        svgContainer.innerHTML = '';
        svgElement.id = `${this.id}-svg`;
        svgContainer.appendChild(svgElement);

        this.currentSvgUrl = desiredUrl;
        this.hasLoadedInlineSvg = true;
        return true;
      } catch (error) {
        console.error('Error loading SVG:', error);
        return false;
      }
    }

    initializeHotspots() {
      const maxButtons = 10;

      const buttons = [];
      const overlays = [];
      const overlayCloses = [];

      for (let i = 0; i < maxButtons; i++) {
        const index = i;
        // Use prefixed IDs to avoid conflicts with other infographics on the same page
        const button = this.querySelector(`#${this.id}-button-${i}`);
        const overlay = this.querySelector(`#${this.id}-overlay-${i}`);
        const overlayClose = this.querySelector(`#${this.id}-overlay-close-${i}`);

        buttons.push(button);
        overlays.push(overlay);
        overlayCloses.push(overlayClose);

        if (overlay) {
          overlay.style.opacity = 0;
          overlay.style.pointerEvents = 'none';
        }

        if (button && overlay) {
          button.style.cursor = 'pointer';
          button.addEventListener('click', () => {
            // close any open overlays
            overlays.forEach((ov, ovIndex) => {
              if (ov && ovIndex !== index) {
                ov.style.opacity = 0;
              }
            });

            // hide any open overlay closes
            overlayCloses.forEach((close, closeIndex) => {
              if (close && closeIndex !== index) {
                close.style.display = 'none';
              }
            });

            overlay.style.opacity = 1;

            if (overlayClose) overlayClose.style.display = 'block';
            this.currentSlideIndex = index;
          });
        }

        if (overlay && overlayClose) {
          overlayClose.style.cursor = 'pointer';
          overlayClose.style.pointerEvents = 'all';
          overlayClose.style.display = 'none';
          overlayClose.addEventListener('click', () => {
            overlay.style.opacity = 0;
            overlayClose.style.display = 'none';
            this.currentSlideIndex = 0;
          });
        }
      }

      // Check for default open panel setting on the current chapter (desktop only)
      const currentChapterElement = this.chapters[this.currentChapter]?.li;
      const shouldOpenDefault = currentChapterElement?.hasAttribute('data-default-open-panel');
      const isDesktop = window.innerWidth >= 1024;

      // If default_open_panel is true and on desktop, open the first panel
      // Check for button-0 first, fall back to button-1 if not found
      if (shouldOpenDefault && isDesktop) {
        const panelIndex = buttons[0] ? 0 : 1;
        const button = buttons[panelIndex];
        const overlay = overlays[panelIndex];
        const overlayClose = overlayCloses[panelIndex];

        if (button && overlay) {
          overlay.style.opacity = 1;
          if (overlayClose) overlayClose.style.display = 'block';
          this.currentSlideIndex = panelIndex;
        }
      }
    }
  }

  if (!customElements.get('infographic-viewer')) {
    customElements.define('infographic-viewer', InfographicViewer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["large-media"] && !Shopify.designMode) return;
  try {
    
  class LargeMediaSvg extends HTMLElement {
    constructor() {
      super();
      this.hasInitialized = false;
      this.intersectionObserver = null;
      this._onResize = this._onResize.bind(this);
      this._resizeRaf = null;
      this.currentBreakpoint = null;
    }

    connectedCallback() {
      // Use Intersection Observer to defer SVG loading until section is near viewport
      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.hasInitialized) {
              this.initializeSection();
            }
          });
        },
        {
          rootMargin: '200px 0px', // Start loading 200px before entering viewport
          threshold: 0,
        },
      );

      this.intersectionObserver.observe(this);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._onResize);
      this.intersectionObserver?.disconnect();
      if (this._resizeRaf) {
        cancelAnimationFrame(this._resizeRaf);
        this._resizeRaf = null;
      }
    }

    initializeSection() {
      this.hasInitialized = true;
      this.intersectionObserver?.disconnect();

      // Load SVG for the current breakpoint
      this.loadSvgForCurrentBreakpoint();

      // Listen for resize to handle breakpoint changes
      window.addEventListener('resize', this._onResize);
    }

    _onResize() {
      if (this._resizeRaf) return;
      this._resizeRaf = requestAnimationFrame(() => {
        this._resizeRaf = null;
        this.loadSvgForCurrentBreakpoint();
      });
    }

    getActiveWrapper() {
      // Determine which wrapper is currently visible based on breakpoint
      const width = window.innerWidth;
      let breakpoint;
      let selector;

      if (width >= 1024) {
        breakpoint = 'desktop';
        selector = '.large-media__image-wrapper--desktop';
      } else if (width >= 768) {
        breakpoint = 'tablet';
        selector = '.large-media__image-wrapper--tablet';
      } else {
        breakpoint = 'mobile';
        selector = '.large-media__image-wrapper--mobile';
      }

      const wrapper = this.querySelector(selector);

      // Fallback: if preferred breakpoint wrapper doesn't exist, try others
      if (!wrapper) {
        const fallbackOrder =
          breakpoint === 'desktop'
            ? ['.large-media__image-wrapper--tablet', '.large-media__image-wrapper--mobile']
            : breakpoint === 'tablet'
              ? ['.large-media__image-wrapper--desktop', '.large-media__image-wrapper--mobile']
              : ['.large-media__image-wrapper--tablet', '.large-media__image-wrapper--desktop'];

        for (const fallbackSelector of fallbackOrder) {
          const fallbackWrapper = this.querySelector(fallbackSelector);
          if (fallbackWrapper) {
            return { wrapper: fallbackWrapper, breakpoint };
          }
        }
      }

      return { wrapper, breakpoint };
    }

    async loadSvgForCurrentBreakpoint() {
      const { wrapper, breakpoint } = this.getActiveWrapper();
      if (!wrapper) return;

      // Check if breakpoint changed
      if (this.currentBreakpoint === breakpoint) return;
      this.currentBreakpoint = breakpoint;

      const svgUrl = wrapper.dataset.svgUrl;
      if (!svgUrl) return; // Not an SVG, nothing to do

      // Check if we already loaded this SVG
      if (wrapper.dataset.svgLoaded === 'true') return;

      try {
        // Use low priority fetch to not compete with critical resources
        const response = await fetch(svgUrl, { priority: 'low' });
        if (!response.ok) throw new Error('Network response was not ok');

        const svgText = await response.text();
        const parser = new DOMParser();
        const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');
        const svgElement = svgDoc.documentElement;

        // Ensure the SVG element is valid
        if (svgElement.tagName.toLowerCase() !== 'svg') {
          console.error('Invalid SVG response');
          return;
        }

        // Apply classes from the original image
        svgElement.classList.add('large-media__media', 'large-media__svg');

        // Replace the img with the inline SVG
        const mediaWrapper = wrapper.querySelector('.media');
        if (mediaWrapper) {
          mediaWrapper.innerHTML = '';
          mediaWrapper.appendChild(svgElement);
        }

        wrapper.dataset.svgLoaded = 'true';
      } catch (error) {
        console.error('Error loading SVG:', error);
      }
    }
  }

  if (!customElements.get('large-media-svg')) {
    customElements.define('large-media-svg', LargeMediaSvg);
  }

  /* Same behavior as blocks/video.liquid — registers when no Video block is on the page */
  if (!customElements.get('video-block')) {
    class VideoBlock extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.video = this.querySelector('.media__video');
        this.playOverlay = this.querySelector('.media__play-overlay');

        if (!this.video) return;

        if (this.playOverlay) {
          this.playOverlay.addEventListener('click', () => {
            this.video.controls = true;
            this.playOverlay.classList.add('hidden');
            this.video.play();
          });
        }

        this.video.addEventListener('play', () => {
          if (this.playOverlay) {
            this.playOverlay.classList.add('hidden');
          }
        });

        this.video.addEventListener('pause', () => {
          if (this.playOverlay) {
            this.playOverlay.classList.remove('hidden');
          }
        });

        this.video.addEventListener('ended', () => {
          if (this.playOverlay) {
            this.playOverlay.classList.remove('hidden');
          }
        });
      }

      connectedCallback() {
        if (typeof Shopify !== 'undefined' && Shopify.designMode) {
          this.init();
        }
      }
    }

    customElements.define('video-block', VideoBlock);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-carousel"] && !Shopify.designMode) return;
  try {
    
  class LogoCarouselComponent extends HTMLElement {
    constructor() {
      super();
      const scrollSpeed = parseInt(this.dataset.scrollSpeed || '50', 10);
      this.SCROLL_SPEED_PX_PER_SEC = scrollSpeed;
      this.resizeTimeout = null;
      this.init();
    }

    init() {
      this.track = this.querySelector('.logo-carousel__track');
      if (!this.track) return;

      this.calculateDuration = this.calculateDuration.bind(this);
      this.handleResize = this.handleResize.bind(this);

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          this.waitForImages().then(() => this.calculateDuration());
        });
      } else {
        setTimeout(() => {
          this.waitForImages().then(() => this.calculateDuration());
        }, 100);
      }

      window.addEventListener('resize', this.handleResize);
    }

    async waitForImages() {
      const images = this.querySelectorAll('img');
      const imagePromises = Array.from(images).map((img) => {
        if (img.complete) return Promise.resolve();
        return new Promise((resolve) => {
          img.addEventListener('load', resolve);
          img.addEventListener('error', resolve);
        });
      });
      return Promise.all(imagePromises);
    }

    calculateDuration() {
      const content = this.track.querySelector('.logo-carousel__content:not([aria-hidden])');
      if (!content) return;

      const contentWidth = content.offsetWidth;
      const duration = contentWidth / this.SCROLL_SPEED_PX_PER_SEC;

      this.style.setProperty('--logo-scroll-duration', `${duration}s`);
    }

    handleResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => this.calculateDuration(), 250);
    }

    connectedCallback() {
      if (window.Shopify && Shopify.designMode) {
        // Update scroll speed if setting changed
        const scrollSpeed = parseInt(this.dataset.scrollSpeed || '50', 10);
        if (this.SCROLL_SPEED_PX_PER_SEC !== scrollSpeed) {
          this.SCROLL_SPEED_PX_PER_SEC = scrollSpeed;
        }
        this.init();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
    }
  }

  if (!customElements.get('logo-carousel-component')) {
    customElements.define('logo-carousel-component', LogoCarouselComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation-b2b-gated"]) return;
  try {
    
  window.onload = function () {
    if (!document.body.classList.contains('can-trigger-cash-out')) {
      return;
    }

    const headerProfitNodes = document.querySelectorAll('.header-profit-balance');
    const yearlyEl = document.getElementById('ep-yearly-profit');
    const totalEl = document.getElementById('ep-total-profit');

    const isOnDashboard = yearlyEl !== null && totalEl !== null;

    const updateProfitBalance = (balance) => {
      headerProfitNodes.forEach((node) => {
        const span = node.querySelector('.current-balance');
        if (span) {
          span.textContent = balance;
          node.classList.remove('hidden');
        }
      });
    };

    const updateDashboardStats = (yearly, total) => {
      const setVal = (container, val) => {
        if (!container) return;
        const numEl = container.querySelector('.ep-body--bignumber');
        if (numEl) {
          numEl.innerText = val;
          container.classList.remove('hidden');
        }
      };
      setVal(yearlyEl, yearly);
      setVal(totalEl, total);
    };

    const balanceCookie = getCookie('profit-balance');
    const statsCookie = getCookie('profit-stats');

    if (balanceCookie) {
      updateProfitBalance(balanceCookie);
    }

    if (statsCookie && isOnDashboard) {
      try {
        const stats = JSON.parse(decodeURIComponent(statsCookie));
        if (stats.yearly && stats.total) {
          updateDashboardStats(stats.yearly, stats.total);
        }
      } catch (e) {
        console.error('Error parsing stats cookie', e);
      }
    }

    if (!balanceCookie) {
      fetch('/apps/portal/api/profit-balance')
        .then((response) => {
          if (!response.ok) throw new Error('Balance API Error');
          return response.json();
        })
        .then((data) => {
          if (data.success && data.data.profitBalance) {
            setCookie('profit-balance', data.data.profitBalance, 1);
            updateProfitBalance(data.data.profitBalance);
          }
        })
        .catch((e) => console.error('Error fetching balance:', e));
    }

    if (isOnDashboard && !statsCookie) {
      fetch('/apps/portal/api/profit-stats')
        .then((response) => {
          if (!response.ok) throw new Error('Stats API Error');
          return response.json();
        })
        .then((data) => {
          if (data.success && data.data) {
            const yearly = data.data.yearlyProfit || '$0.00';
            const total = data.data.totalProfit || '$0.00';

            updateDashboardStats(yearly, total);

            const stats = JSON.stringify({ yearly: yearly, total: total });
            setCookie('profit-stats', encodeURIComponent(stats), 1);
          }
        })
        .catch((e) => console.error('Error fetching stats:', e));
    }
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-page-navigation"] && !Shopify.designMode) return;
  try {
    
  class OnPageNavigation extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
      this.sections = [];
      this.links = [];
      this.activeLink = null;
      this.isScrolling = false;
      this.scrollTimeout = null;
      this.boundHandleSectionLoad = this.handleSectionLoad.bind(this);
    }

    connectedCallback() {
      this.links = Array.from(this.querySelectorAll('.on-page-navigation__link[data-anchor="true"]'));
      if (this.links.length === 0) return;

      this.refreshSections();
      if (this.sections.length === 0) return;

      this.setupIntersectionObserver();
      this.setupClickHandlers();
      this.setupScrollListener();
      this.updateActiveOnScroll();

      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.boundHandleSectionLoad);
      }
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }

      window.removeEventListener('scroll', this.handleScroll);

      if (Shopify.designMode) {
        document.removeEventListener('shopify:section:load', this.boundHandleSectionLoad);
      }
    }

    refreshSections() {
      this.sections = this.links
        .map((link) => {
          const href = link.getAttribute('href');
          if (!href || !href.startsWith('#')) return null;
          return document.getElementById(href.slice(1));
        })
        .filter(Boolean);
    }

    setupIntersectionObserver() {
      const rootMarginTop = -this.offsetHeight - 1;

      this.observer = new IntersectionObserver(
        () => {
          if (!this.isScrolling) {
            this.updateActiveOnScroll();
          }
        },
        {
          rootMargin: `${rootMarginTop}px 0px -50% 0px`,
          threshold: [0, 0.1, 0.25, 0.5],
        },
      );

      this.sections.forEach((section) => this.observer.observe(section));
    }

    setupClickHandlers() {
      this.links.forEach((link) => {
        link.addEventListener('click', () => {
          const href = link.getAttribute('href');
          if (!href || !href.startsWith('#')) return;

          this.isScrolling = true;
          this.setActiveLink(link);
        });
      });
    }

    setupScrollListener() {
      this.handleScroll = () => {
        if (this.scrollTimeout) {
          clearTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
          this.isScrolling = false;
          this.updateActiveOnScroll();
        }, 100);
      };

      window.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    updateActiveOnScroll() {
      const navBottom = this.getBoundingClientRect().bottom;
      const closestSection = this.findClosestSection(navBottom);

      if (!closestSection) return;

      const targetLink = this.links.find((link) => link.getAttribute('href') === `#${closestSection.id}`);

      if (targetLink && targetLink !== this.activeLink) {
        this.setActiveLink(targetLink);
      }
    }

    findClosestSection(navBottom) {
      let closestSection = null;
      let closestDistance = Infinity;

      // Find sections visible below the nav
      for (const section of this.sections) {
        const rect = section.getBoundingClientRect();

        if (rect.bottom > navBottom && rect.top < window.innerHeight) {
          const distance = Math.abs(rect.top - navBottom);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestSection = section;
          }
        }
      }

      if (closestSection) return closestSection;

      // Fallback: if at bottom of page, use last section
      const isAtBottom = window.innerHeight + window.scrollY >= document.body.scrollHeight - 50;
      if (isAtBottom && this.sections.length > 0) {
        return this.sections[this.sections.length - 1];
      }

      // Fallback: find section closest to nav
      for (const section of this.sections) {
        const distance = Math.abs(section.getBoundingClientRect().top - navBottom);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestSection = section;
        }
      }

      return closestSection;
    }

    setActiveLink(link) {
      this.links.forEach((l) => l.classList.remove('on-page-navigation__link--active'));

      if (link) {
        link.classList.add('on-page-navigation__link--active');
        this.activeLink = link;
        this.scrollLinkIntoView(link);
      }
    }

    scrollLinkIntoView(link) {
      const list = this.querySelector('.on-page-navigation__list');
      if (!list) return;

      const listRect = list.getBoundingClientRect();
      const linkRect = link.getBoundingClientRect();

      if (linkRect.left < listRect.left || linkRect.right > listRect.right) {
        link.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    handleSectionLoad() {
      if (this.observer) {
        this.observer.disconnect();
      }

      this.refreshSections();

      if (this.sections.length > 0) {
        this.setupIntersectionObserver();
        this.updateActiveOnScroll();
      }
    }
  }

  if (!customElements.get('on-page-navigation')) {
    customElements.define('on-page-navigation', OnPageNavigation);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid-with-tabs"] && !Shopify.designMode) return;
  try {
    
  class ProductGridTabs extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.buttons = this.querySelectorAll('[role="tab"]');
      this.panels = this.querySelectorAll('[role="tabpanel"]');

      if (!this.buttons.length || !this.panels.length) return;

      // Set initial state
      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => this.switchTab(index));

        // Set tabindex for initial state
        if (index === 0) {
          button.setAttribute('tabindex', '0');
          button.classList.add('product-grid-tabs__button--active');
          this.addUnderline(button);
        } else {
          button.setAttribute('tabindex', '-1');
        }
      });

      // Ensure first panel is visible
      if (this.panels.length > 0) {
        this.panels[0].classList.add('product-grid-tabs__panel--active');
        this.panels.forEach((panel, i) => {
          if (i !== 0) {
            panel.classList.remove('product-grid-tabs__panel--active');
          }
        });
      }
    }

    addUnderline(button) {
      // Remove existing underline if any
      const existingUnderline = button.querySelector('.product-grid-tabs__underline');
      if (!existingUnderline) {
        const underline = document.createElement('span');
        underline.className = 'product-grid-tabs__underline';
        underline.setAttribute('aria-hidden', 'true');
        const template = this.querySelector('.product-grid-tabs__underline-template');
        if (template) {
          underline.innerHTML = template.innerHTML;
        }
        button.appendChild(underline);
      }
    }

    removeUnderline(button) {
      const underline = button.querySelector('.product-grid-tabs__underline');
      if (underline) {
        underline.remove();
      }
    }

    switchTab(index) {
      // Update buttons
      this.buttons.forEach((btn, i) => {
        const isActive = i === index;
        if (isActive) {
          btn.classList.add('product-grid-tabs__button--active');
          btn.setAttribute('aria-selected', 'true');
          btn.setAttribute('tabindex', '0');
          this.addUnderline(btn);

          // Scroll active tab into view on mobile (when tabs overflow)
          const nav = btn.closest('.product-grid-tabs__nav');
          if (nav && nav.scrollWidth > nav.clientWidth) {
            btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        } else {
          btn.classList.remove('product-grid-tabs__button--active');
          btn.setAttribute('aria-selected', 'false');
          btn.setAttribute('tabindex', '-1');
          this.removeUnderline(btn);
        }
      });

      // Update panels
      this.panels.forEach((panel, i) => {
        if (i === index) {
          panel.classList.add('product-grid-tabs__panel--active');
        } else {
          panel.classList.remove('product-grid-tabs__panel--active');
        }
      });

      // Refresh carousels in the newly active panel
      // (they may have incorrect button visibility if they were hidden when initialized)
      const activePanel = this.panels[index];
      if (activePanel) {
        const carousels = activePanel.querySelectorAll('carousel-component');
        carousels.forEach((carousel) => {
          if (carousel.updateButtons) {
            requestAnimationFrame(() => carousel.updateButtons());
          }
        });
      }
    }

    connectedCallback() {
      // Reinitialize when section is reloaded in theme editor
      if (Shopify && Shopify.designMode) {
        this.init();
      }
    }
  }

  if (!customElements.get('product-grid-tabs')) {
    customElements.define('product-grid-tabs', ProductGridTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-modal"] && !Shopify.designMode) return;
  try {
    
  class QuizController extends HTMLElement {
    constructor() {
      super();
      this.answerbuttons = null;
      this.submitbutton = null;
      this.selectedAnswer = null;
    }

    connectedCallback() {
      console.log('QuizController connected');
      const answerbuttons = this.querySelectorAll('.quiz-answer');
      this.answerbuttons = answerbuttons;

      this.submitbutton = this.querySelector('.quiz-modal__content__footer .ep-button');

      answerbuttons.forEach((buttonWrapper) => {
        const btn = buttonWrapper.querySelector('button');
        btn.addEventListener('click', () => {
          // Deselect all other answers first (radio behavior)
          this.answerbuttons.forEach((otherButton) => {
            otherButton.classList.remove('quiz-answer--selected');
          });
          // Select only the clicked answer
          buttonWrapper.classList.add('quiz-answer--selected');
          this.selectedAnswer = buttonWrapper.getAttribute('data-answer-value');
        });
      });

      this.submitbutton.addEventListener('click', (event) => {
        event.preventDefault();
        if (!this.selectedAnswer) {
          alert('Please select an answer to proceed.');
        } else {
          const quizUrl = this.getAttribute('data-quiz-url');
          const url = new URL(quizUrl);
          url.searchParams.set('question_one', this.selectedAnswer);

          console.log('quizUrl', url.toString());

          window.quizPopup = window.tf.createPopup(url.toString());
          window.quizPopup.open();
        }
      });
    }
    disconnectedCallback() {}
  }

  if (!customElements.get('quiz-controller')) {
    customElements.define('quiz-controller', QuizController);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rtb-carousel"] && !Shopify.designMode) return;
  try {
    
  class RTBCarouselComponent extends HTMLElement {
    constructor() {
      super();
      const scrollSpeed = parseInt(this.dataset.scrollSpeed || '50', 10);
      this.SCROLL_SPEED_PX_PER_SEC = scrollSpeed;
      this.resizeTimeout = null;
      this.init();
    }

    init() {
      this.track = this.querySelector('.rtb-carousel__track');
      if (!this.track) return;

      // Bind methods
      this.calculateDuration = this.calculateDuration.bind(this);
      this.handleResize = this.handleResize.bind(this);

      // Wait for fonts to load and content to render
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.calculateDuration());
      } else {
        setTimeout(() => this.calculateDuration(), 100);
      }

      // Add resize listener
      window.addEventListener('resize', this.handleResize);
    }

    calculateDuration() {
      const content = this.track.querySelector('.rtb-carousel__content:not([aria-hidden])');
      if (!content) return;

      const contentWidth = content.offsetWidth;
      const duration = contentWidth / this.SCROLL_SPEED_PX_PER_SEC;

      this.style.setProperty('--rtb-scroll-duration', `${duration}s`);
    }

    handleResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => this.calculateDuration(), 250);
    }

    connectedCallback() {
      // Reinitialize when section is reloaded in theme editor
      if (window.Shopify && Shopify.designMode) {
        // Update scroll speed if setting changed
        const scrollSpeed = parseInt(this.dataset.scrollSpeed || '50', 10);
        if (this.SCROLL_SPEED_PX_PER_SEC !== scrollSpeed) {
          this.SCROLL_SPEED_PX_PER_SEC = scrollSpeed;
        }
        this.init();
      }
    }

    disconnectedCallback() {
      // Clean up event listener when element is removed
      window.removeEventListener('resize', this.handleResize);
    }
  }

  if (!customElements.get('rtb-carousel-component')) {
    customElements.define('rtb-carousel-component', RTBCarouselComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["side-by-side-stats"] && !Shopify.designMode) return;
  try {
    
  class StatsBackgroundSync extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      if (this.handleResize) {
        window.removeEventListener('resize', this.handleResize);
      }

      this.leftColumn = this.querySelector('.side-by-side-stats__content .ep-container > .shopify-block:first-child');
      this.statsColumn = this.querySelector('.side-by-side-stats__content .ep-container > .shopify-block:last-child');
      this.leftBackground = this.querySelector('.side-by-side-stats__background--left');
      this.rightBackground = this.querySelector('.side-by-side-stats__background--right');
      this.imageWrapper = this.querySelector('.side-by-side-stats__image-wrapper');

      if (!this.statsColumn && !this.leftColumn) return;

      this.syncLayout = this.syncLayout.bind(this);
      this.syncHeight = this.syncHeight.bind(this);
      this.syncBackgrounds = this.syncBackgrounds.bind(this);
      this.handleResize = this.syncLayout;

      this.resizeObserver = new ResizeObserver(this.syncLayout);

      if (this.leftColumn) {
        this.resizeObserver.observe(this.leftColumn);
      }

      if (this.statsColumn) {
        this.resizeObserver.observe(this.statsColumn);
      }

      this.syncLayout(); // Initial sync
      window.addEventListener('resize', this.handleResize);
    }

    syncHeight() {
      if (this.statsColumn && this.imageWrapper) {
        const height = this.statsColumn.offsetHeight;
        this.imageWrapper.style.height = `${height}px`;
      }
    }

    syncBackgrounds() {
      const sectionRect = this.getBoundingClientRect();

      if (this.leftBackground && this.leftColumn) {
        const leftRect = this.leftColumn.getBoundingClientRect();
        const leftTop = leftRect.top - sectionRect.top;
        this.leftBackground.style.top = `${leftTop}px`;
        this.leftBackground.style.height = `${leftRect.height}px`;
      } else if (this.leftBackground) {
        this.leftBackground.style.height = '0';
      }

      const rightTarget = this.statsColumn || null;

      if (this.rightBackground && rightTarget) {
        const rightRect = rightTarget.getBoundingClientRect();
        const rightTop = rightRect.top - sectionRect.top;
        this.rightBackground.style.top = `${rightTop}px`;
        this.rightBackground.style.height = `${rightRect.height}px`;
      } else if (this.rightBackground) {
        this.rightBackground.style.height = '0';
      }
    }

    syncLayout() {
      this.syncHeight();
      this.syncBackgrounds();
    }

    connectedCallback() {
      // Reinitialize when section is reloaded in theme editor
      if (window.Shopify && window.Shopify.designMode) {
        this.init();
      }
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      if (this.handleResize) {
        window.removeEventListener('resize', this.handleResize);
      }
    }
  }

  if (!customElements.get('stats-background-sync')) {
    customElements.define('stats-background-sync', StatsBackgroundSync);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["side-by-side-text"] && !Shopify.designMode) return;
  try {
    
  class SideBySideTextComponent extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
    }

    init() {
      // Find all columns (shopify-block elements)
      const columns = this.querySelectorAll('.shopify-block .column');
      if (columns.length < 2) return;

      const firstColumn = columns[0];
      const secondColumn = columns[1];

      // Check if the section has the continue numbering setting enabled
      // Check both dataset property and getAttribute for reliability
      const dataAttr = this.getAttribute('data-continue-list-numbering');
      const shouldContinue = dataAttr === 'true' || this.dataset.continueListNumbering === 'true';

      // Find all ordered lists within each column div (scoped to that column only)
      const firstColumnLists = firstColumn.querySelectorAll('ol');
      const secondColumnLists = secondColumn.querySelectorAll('ol');

      if (shouldContinue) {
        // Continue numbering: ensure first column starts at 1, then continue in second
        // Explicitly set start="1" on first column lists to override any existing values
        firstColumnLists.forEach((list) => {
          list.setAttribute('start', '1');
        });

        if (firstColumnLists.length === 0) return;

        // Count items in first column (now that they start at 1)
        let totalItems = 0;
        firstColumnLists.forEach((list) => {
          const itemCount = list.querySelectorAll('li').length;
          totalItems += itemCount;
        });

        if (totalItems === 0) return;

        // Set start attribute on second column lists to continue numbering
        let currentStart = totalItems + 1;
        secondColumnLists.forEach((list) => {
          list.setAttribute('start', currentStart.toString());
          currentStart += list.querySelectorAll('li').length;
        });
      } else {
        // Don't continue: ensure both columns start at 1 (remove any existing start attributes)
        firstColumnLists.forEach((list) => {
          list.removeAttribute('start');
        });
        secondColumnLists.forEach((list) => {
          list.removeAttribute('start');
        });
      }
    }

    connectedCallback() {
      // Use a small delay to ensure DOM is fully ready
      setTimeout(() => {
        this.init();
      }, 100);

      // Watch for changes to start attributes and reapply logic if needed
      const columns = this.querySelectorAll('.shopify-block');
      if (columns.length >= 2) {
        // Find all lists within column divs only
        const allLists = Array.from(columns).flatMap((block) => {
          return Array.from(block.querySelectorAll('ol'));
        });
        if (allLists.length > 0) {
          this.observer = new MutationObserver(() => {
            // Debounce to avoid excessive calls
            clearTimeout(this.observerTimeout);
            this.observerTimeout = setTimeout(() => {
              this.init();
            }, 100);
          });

          allLists.forEach((list) => {
            this.observer.observe(list, {
              attributes: true,
              attributeFilter: ['start'],
            });
          });
        }
      }

      // Reinitialize when section is reloaded in theme editor
      if (Shopify && Shopify.designMode) {
        document.addEventListener('shopify:section:load', () => {
          setTimeout(() => {
            this.init();
          }, 150);
        });

        // Also watch for block updates
        document.addEventListener('shopify:block:select', () => {
          setTimeout(() => {
            this.init();
          }, 150);
        });
      }
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      if (this.observerTimeout) {
        clearTimeout(this.observerTimeout);
      }
    }
  }

  if (!customElements.get('side-by-side-text-component')) {
    customElements.define('side-by-side-text-component', SideBySideTextComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
  class TabsSection extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.buttons = this.querySelectorAll('[role="tab"]');
      this.panels = this.querySelectorAll('[role="tabpanel"]');
      this.tabsNav = this.querySelector('.tabs__nav');

      // Set initial state
      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => this.switchTab(index));

        // Set tabindex for initial state
        if (index === 0) {
          button.setAttribute('tabindex', '0');
          button.classList.add('tabs__button--active');
        } else {
          button.setAttribute('tabindex', '-1');
        }
      });

      // Set initial nav position class (first tab is active)
      this.updateNavPositionClass(0);

      // Ensure first panel is visible
      if (this.panels.length > 0) {
        this.panels[0].classList.add('tabs__panel--active');
        this.panels.forEach((panel, i) => {
          if (i !== 0) {
            panel.classList.remove('tabs__panel--active');
          }
        });
      }
    }

    updateNavPositionClass(activeIndex) {
      // Remove existing position classes
      this.tabsNav.classList.remove('tabs__nav--active-first', 'tabs__nav--active-last');

      // Add class based on active tab position
      if (activeIndex === 0) {
        this.tabsNav.classList.add('tabs__nav--active-first');
      } else if (activeIndex === this.buttons.length - 1) {
        this.tabsNav.classList.add('tabs__nav--active-last');
      } else {
        this.tabsNav.classList.add('tabs__nav--active-first', 'tabs__nav--active-last');
      }
    }

    switchTab(index) {
      // Update buttons
      this.buttons.forEach((btn, i) => {
        const isActive = i === index;
        if (isActive) {
          btn.classList.add('tabs__button--active');
        } else {
          btn.classList.remove('tabs__button--active');
        }
        btn.setAttribute('aria-selected', isActive);
        btn.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      // Update nav position class for curved corners
      this.updateNavPositionClass(index);

      // Update panels - Remove active from all, then add to selected
      this.panels.forEach((panel) => {
        panel.classList.remove('tabs__panel--active');
      });

      if (this.panels[index]) {
        this.panels[index].classList.add('tabs__panel--active');
      }
    }

    connectedCallback() {
      // Reinitialize when section is reloaded in theme editor
      if (Shopify && Shopify.designMode) {
        this.init();
      }
    }
  }

  if (!customElements.get('tabs-section')) {
    customElements.define('tabs-section', TabsSection);
  }

  } catch(e) { console.error(e); }
})();
})();
